/**
 * The "Saved" look, shared by every control that reports durable saved state.
 *
 * There are two doors to the same state on the same screen — the card's
 * connected Save bar (`CardSaveDrawer`) and the quick-view's Save CTA
 * (`ProductDetailSheet`'s `LikeCta`) — and before THE-690 they disagreed: the
 * sheet settled into liked-rose while the bar settled into a clay tint under
 * clay text, so saving from the guide produced two different "Saved" looks
 * depending on which door you used. The board's call was the rose one.
 *
 * These live in a module rather than in `theme.color` because they are a
 * ROLE ("this control is saved"), not a palette entry, and because the fill is
 * an alpha of the same hue as the ink — the pair only makes sense together.
 * Import both or neither; a control that takes the fill without the ink is the
 * drift this file exists to prevent.
 *
 * Alpha, not a flat hex, so the tint composites over whatever the control sits
 * on — the sheet's cream and the card's white both work without a second
 * token.
 */
export const SAVED_CTA_FILL = 'hsl(var(--liked) / 0.14)';
export const SAVED_CTA_INK = 'hsl(var(--liked))';
